export const AwardsError = require('./awards-error.jpg');
export const GalleryError = require('./gallery-error.jpg');
export const PackagesError = require('./packages-error.jpg');
